import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router-dom";

// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import { useContext } from "react";
import Loader from "../components/common/Loader";
import OfflinePinForm from "../components/forms/OfflinePinForm";
import { OfflineInitialConfForm } from "../components/forms/OfflineInitialConfForm";

interface IParams {
  tenant: string;
}

const OfflineAuthLayout: React.FC<RouteComponentProps<IParams>> = ({
  history,
  match,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { isNativeApp, updateOfflineModeEnabled } = rootStore.commonStore;
  const { loadNativeAppConfFromDb, nativeAppConf, setDirectTenantAccess } = rootStore.offlineStore;
  const [confLoaded, setConfLoaded] = useState(false);

  useEffect(() => {
    if (!isNativeApp) history.push("/");
    else updateOfflineModeEnabled(true);

    if (match.params.tenant) setDirectTenantAccess(match.params.tenant);

    loadNativeAppConfFromDb()
      .then(() => setConfLoaded(true))
      .catch(() => setConfLoaded(true));

    document.body.classList.remove("pt-0");
    document.body.classList.add("form-membership");

    return () => {

    };
  }, [loadNativeAppConfFromDb, updateOfflineModeEnabled, history, isNativeApp, match.params.tenant, setDirectTenantAccess]);

  if (!confLoaded) return <Loader />;

  return (
    <Container>
      <Row>
        <Col lg="12">
          <Row className="justify-content-center">
            {!nativeAppConf ? <OfflineInitialConfForm /> : <OfflinePinForm configuration={nativeAppConf} />}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default observer(OfflineAuthLayout);
